import { createUseStyles, negative } from '@pushpay/styles';
import { headerHeightMobile } from '../header';
import { customizeScrollBar } from '../shared-styles';
export const sidebarCollapsedWidthPx = 64;
export const sidebarExpandedWidthPx = 250;
const shadowStyles = {
  width: '100%',
  height: '8px',
  zIndex: 1,
  flexShrink: 0,
  pointerEvents: 'none'
};
const listenerStyles = {
  height: '1px',
  pointerEvents: 'none'
};
export const useStyles = createUseStyles(theme => ({
  root: {
    alignItems: 'flex-start',
    backgroundColor: theme.colors['color-background-surface'],
    borderRight: `1px solid ${theme.colors['color-border-surface']}`,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
    position: 'relative'
  },
  drawerMobile: {
    backgroundColor: theme.colors['color-background-surface'],
    display: 'flex',
    flexDirection: 'column',
    top: headerHeightMobile
  },
  drawerMask: {
    top: headerHeightMobile
  },
  expanderText: {
    marginLeft: theme.SPACING.XSMALL
  },
  expanderTooltip: {
    display: 'flex',
    width: '100%'
  },
  expanderButton: {
    alignItems: 'center',
    borderBottom: `1px solid ${theme.colors['color-border-surface']}`,
    color: theme.colors['palette-grey-dark-200'],
    display: 'flex',
    fontSize: '14px',
    height: '48px',
    justifyContent: 'flex-start',
    padding: `${theme.SPACING.SMALL} 22px`,
    whiteSpace: 'nowrap',
    width: '100%',
    overflow: 'hidden',
    '&:hover': {
      backgroundColor: theme.colors['product-color-light-400']
    },
    '&:focus-visible': {
      outline: '1px auto',
      outlineColor: theme.colors['product-color'],
      outlineOffset: '-1px'
    }
  },
  expanderTextOpen: {
    opacity: 1
  },
  expanderTextCollapsed: {
    opacity: 0
  },
  icon: {
    flexShrink: 0
  },
  iconCollapse: {},
  iconExpand: {
    transform: 'rotate(180deg)'
  },
  topSection: {
    flexGrow: 1,
    marginTop: negative(theme.SPACING.XSMALL),
    overflow: 'hidden auto',
    position: 'relative',
    width: '100%',
    ...customizeScrollBar(theme)
  },
  topSectionCollapsed: {},
  scrollListenerTop: { ...listenerStyles,
    marginBottom: '-1px'
  },
  scrollListenerBottom: { ...listenerStyles,
    marginTop: '-1px'
  },
  topShadow: { ...shadowStyles,
    background: theme.ELEVATION.EDGE_SHADOW('top')
  },
  bottomShadow: { ...shadowStyles,
    background: theme.ELEVATION.EDGE_SHADOW('bottom'),
    marginTop: negative(theme.SPACING.XSMALL)
  },
  bottomSection: {
    borderTop: `1px solid ${theme.colors['color-border-surface']}`,
    flexShrink: 0,
    width: '100%'
  },
  bottomSectionCollapsed: {}
}));